module.exports = __webpack_public_path__ + "img/new_slide_3.5cb81ae0.jpg";